/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Monthly_DescriptionInputs */

const es_billing_monthly_description = /** @type {(inputs: Billing_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo total por mes durante los últimos períodos.`)
};

const en_billing_monthly_description = /** @type {(inputs: Billing_Monthly_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total cost per month over recent periods.`)
};

/**
* | output |
* | --- |
* | "Total cost per month over recent periods." |
*
* @param {Billing_Monthly_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_monthly_description = /** @type {((inputs?: Billing_Monthly_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Monthly_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_monthly_description(inputs)
	return en_billing_monthly_description(inputs)
});
export { billing_monthly_description as "billing.monthly.description" }